import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import UserAdministration from './pages/user-administration';
import DashboardOverview from './pages/dashboard-overview';
import SystemConfiguration from './pages/system-configuration';
import HistoryAndAuditTrail from './pages/history-and-audit-trail';
import VinConsultation from './pages/vin-consultation';
import LoginAndAuthentication from './pages/login-and-authentication';
import LandingPage from './pages/landing-page';
import { isSessionValid } from './services/localStorage';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  if (!isSessionValid()) {
    return <Navigate to="/login-and-authentication" replace />;
  }
  return children;
};

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/login-and-authentication" element={<LoginAndAuthentication />} />

        {/* Protected routes */}
        <Route path="/dashboard-overview" element={<ProtectedRoute><DashboardOverview /></ProtectedRoute>} />
        <Route path="/vin-consultation" element={<ProtectedRoute><VinConsultation /></ProtectedRoute>} />
        <Route path="/history-and-audit-trail" element={<ProtectedRoute><HistoryAndAuditTrail /></ProtectedRoute>} />
        <Route path="/user-administration" element={<ProtectedRoute><UserAdministration /></ProtectedRoute>} />
        <Route path="/system-configuration" element={<ProtectedRoute><SystemConfiguration /></ProtectedRoute>} />

        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
